/**
 * Query key factory for Catalog module
 * Ensures consistent cache keys across all hooks
 */
export const catalogKeys = {
  all: ['catalog'] as const,

  // Product attributes
  attributes: () => [...catalogKeys.all, 'attributes'] as const,
  attribute: (sku: string) => [...catalogKeys.attributes(), sku] as const,

  // Product description
  descriptions: () => [...catalogKeys.all, 'description'] as const,
  description: (sku: string) => [...catalogKeys.descriptions(), sku] as const,

  // Product related
  related: () => [...catalogKeys.all, 'related'] as const,
  relatedBySku: (sku: string) => [...catalogKeys.related(), sku] as const,

  // Auto-related
  autoRelatedSkus: (sku: string) => [...catalogKeys.all, 'autoRelatedSkus', sku] as const,
  autoRelatedProducts: (skus: string[]) => [...catalogKeys.all, 'autoRelatedProducts', skus] as const,

  // Reward points
  rewardPoints: (sku: string) => [...catalogKeys.all, 'rewardPoints', sku] as const,
} as const
